interface Props {
  num: string;          // e.g. "02"
  command: string;      // e.g. "> stack.json"
  caption?: string;     // e.g. "What I reach for first."
}

export const SectionHeader = ({ num, command, caption }: Props) => {
  const [chev, ...rest] = command.split(" ");
  return (
    <header className="sectionHeader">
      <span className="sectionHeader__num">{"// "}{num}</span>
      <span className="sectionHeader__cmd">
        <span className="sectionHeader__chev">{chev}</span>{" "}
        {rest.join(" ")}
      </span>
      <span className="sectionHeader__line" aria-hidden="true" />
      {caption && <span className="sectionHeader__caption">{caption}</span>}
    </header>
  );
};
